module.exports = __webpack_public_path__ + "static/img/banner_f001.1f6feda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_f001.jpg
// module id = J1aM
// module chunks = 40